module.exports = __webpack_public_path__ + "img/Loose Stone.49a37c36.png";